import React, { useState } from 'react';
import { useWithdrawalAccounts } from 'queries/withdrawalAccounts';
import Heading from '@hubins/components/Heading';
import SimpleTable from 'modules/Tables/SimpleTable';
import __ from 'localisation';
import LoadingBar from '@hubins/components/LoadingIndicators';
import Button from '@hubins/components/Button';
import EditModal from './EditModal';
import { useMiddleman } from '@hubins/middleman';
import WithdrawalAccountHistory from '@hubins/components/WithdrawalAccountHistory';



const loadingObj = {
  account_number: <LoadingBar />,
  bic_code: <LoadingBar />,
};

const loadingState = [
  {
    account_number: <LoadingBar />,
    bic_code: <LoadingBar />,
  },
]

const WithdrawalAccounts = ({ portfolioUuid, backOfficeUser }) => {
  const middleman = useMiddleman();


  const [editAccount, setEditAccount] = useState<{ uuid: string | null, account_number: string, bic_code: string } | null>(null);

  const { data: withdrawalAccounts, isLoading, isFetched, refetch } = useWithdrawalAccounts(portfolioUuid);

  const deleteWithdrawalAccount = async (withdrawalAccountUuid: string) => {
    if (window.confirm(__('are_you_sure_you_want_to_delete_this_withdrawal_account'))) {
      await middleman.promiseDelete(`/ql/crm/withdrawal-accounts/${portfolioUuid}/${withdrawalAccountUuid}`);
      refetch();
    }
  }

  const headers = [
    {
      Header: '',
      accessor: 'edit',
      width: 25,
      Cell: ({ row }) => {
        return (
          <Button icon="pencil write 2" onClick={() => setEditAccount(row.original)} onlyIcon={true} />
      );
      },
    },
    {
      Header: '',
      accessor: 'history',
      width: 25,
      Cell: ({ row }) => {
        return <WithdrawalAccountHistory withdrawalAccountUuid={row.original.uuid} />
      }
    },
    {
      Header: '',
      accessor: 'delete',
      Cell: ({ row }) => {
        return <Button icon="Bin by Streamlinehq" onClick={() => deleteWithdrawalAccount(row.original.uuid)} onlyIcon={true} />
      }
    },
    {
      Header: __('account_number'),
      accessor: 'account_number',
    },
    {
      Header: __('bic_code'),
      accessor: 'bic_code',
    },
  ];



  return (
    <>
      {editAccount && <EditModal withdrawalAccount={editAccount} setWithdrawalAccount={setEditAccount} refetch={refetch} portfolioUuid={portfolioUuid} />}
      <Heading size="5" className="s-bottom-m s-top-l">
        {__('withdrawal_accounts')}
      </Heading>
      <SimpleTable headers={headers} data={isLoading || !isFetched ? loadingState : withdrawalAccounts?.data || []} />
      {(backOfficeUser && isFetched && withdrawalAccounts?.data && Array.isArray(withdrawalAccounts.data) && withdrawalAccounts.data.length === 0) && (
        <Button className="s-top-m" size="medium" icon="add" onClick={() => setEditAccount({
          uuid: null,
          account_number: '',
          bic_code: '',
        })}>
          {__('add_withdrawal_account')}
        </Button>
      )}
    </>
  );
};

export default WithdrawalAccounts;